import React from 'react';
import Box from '@mui/material/Box';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { getProductImageUrl } from 'src/utils/image';
import { ProductImage } from 'src/components/BeaconV2Components/ProductCard/ProductCard';
import { getQueryParamValue } from 'src/utils/app';
import { getCurrentContentVersion } from 'src/utils/app';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { BEACON_SUBTABS, BEACON_TABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';

/**
 * Compact product info card for the Library Review header
 * Data sourcing follows the subtab header multi-sku card pattern
 */
export const LibraryProductHeaderCard: React.FC = () => {
  const stacklineSku = getQueryParamValue('stacklineSku', '');
  const sku = getQueryParamValue('sku', '');
  const { beaconNavigator } = useBeaconNavigator();

  const handleSkuClick = () => {
    const version = getCurrentContentVersion();
    const contentTab =
      version === 'content'
        ? BEACON_TABS.CONTENT
        : version === 'contentV2'
        ? BEACON_TABS.CONTENT_V2
        : BEACON_TABS.CONTENT_V3;

    beaconNavigator
      .setPathname(`/product/${stacklineSku}`)
      .updateSearchParams({ tab: contentTab, subtab: BEACON_SUBTABS.CONTENT_UTILIZATION })
      .go();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 12px',
        borderRadius: '8px',
        border: `1px solid ${colors.graysSecondary}`,
        background: colors.contentGenBackground,
        height: '60px',
        width: '172px'
      }}
    >
      <ProductImage
        imageUri={getProductImageUrl(stacklineSku)}
        mainDisplayTitle={''}
        secondaryDisplayTitle={''}
        width={40}
        height={40}
        imageStyle={{
          flexShrink: 0,
          background: 'lightgray',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat'
        }}
      />
      <Flex flexDirection="column" gap={2} sx={{ marginLeft: 'auto' }}>
        <Text
          variant="body2"
          sx={{ color: colors.grey, fontSize: '12px', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.96px' }}
        >
          Retailer SKU
        </Text>
        <Text
          variant="body2"
          onClick={handleSkuClick}
          sx={{
            color: colors.darkBlue,
            fontSize: '12px',
            textTransform: 'uppercase',
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          {sku}
        </Text>
      </Flex>
    </Box>
  );
};

export default LibraryProductHeaderCard;


